import { render, staticRenderFns } from "./GasData.vue?vue&type=template&id=296c5704&scoped=true"
import script from "./GasData.vue?vue&type=script&lang=js"
export * from "./GasData.vue?vue&type=script&lang=js"
import style0 from "./GasData.vue?vue&type=style&index=0&id=296c5704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c5704",
  null
  
)

export default component.exports